import gql from 'graphql-tag';

export const REGISTER_PROJECT_SUCCESS_PAGE_FRAGMENT = gql`
  fragment registerProjectSuccessPage on RegisterProjectSuccessPageType {
    createdAt
    updatedAt
    id
    title
    image
    text
    button1Text
    button1Url
    button2Text
    button2Url
  }
`;
